"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _prepareChildKeys = _interopRequireDefault(require("./prepareChildKeys"));

var _getIn = _interopRequireDefault(require("unmutable/lib/getIn"));

var _pipeWith = _interopRequireDefault(require("unmutable/lib/util/pipeWith"));

var _default = function _default(key) {
  return function (parcelData) {
    if (typeof key === "string") {
      return key;
    }

    return (0, _pipeWith.default)(parcelData, (0, _prepareChildKeys.default)(), (0, _getIn.default)(['child', key, 'key']));
  };
};

exports.default = _default;